import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { FormattedMessage } from 'react-intl';

import ContentWrapper from 'components/ContentWrapper';
import ActionButton from 'components/ActionButton';
import Paper from 'components/Paper';

const toLogin = () => window.location.replace(LOGIN_URL);

const Loggedout = () => (
  <ContentWrapper>
    <Paper topMargin={false}>
      <Grid fluid>
        <Row middle="xs" center="xs" style={{ margin: '4rem 0 3rem', textAlign: 'center' }}>
          <Col xs={12}>
            <h4>
              <FormattedMessage id="loggedout.title" />
            </h4>
          </Col>
        </Row>
        <Row middle="xs" center="xs" style={{ margin: '2rem 0', textAlign: 'center' }}>
          <Col xs={12}>
            <ActionButton localeId="loggedout.action" secondary border onClick={toLogin} />
          </Col>
        </Row>
      </Grid>
    </Paper>
  </ContentWrapper>
);

export default Loggedout;
